import React, { createContext, useCallback, useContext, useState } from "react";
import { Snackbar, Alert } from "@mui/material";

const GlobalAlertContext = createContext({
  showAlert: () => {},
});

export const useGlobalAlert = () => useContext(GlobalAlertContext);

export const AlertProvider = ({ children }) => {
  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showAlert = useCallback((message, severity = "success") => {
    setAlertState({ open: true, message, severity });
  }, []);

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setAlertState((prev) => ({ ...prev, open: false }));
  };

  return (
    <GlobalAlertContext.Provider value={{ showAlert }}>
      {children}
      <Snackbar
        open={alertState.open}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={alertState.severity} sx={{ width: "100%" }}>
          {alertState.message}
        </Alert>
      </Snackbar>
    </GlobalAlertContext.Provider>
  );
};
